"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = void 0;

var React = __importStar(require("react"));

var core_1 = require("@emotion/core");

var typefaces_1 = require("./typefaces");

var globals_1 = require("./globals");

function GlobalStyles() {
  return (0, _core.jsx)(core_1.Global, {
    styles: function styles(theme) {
      var fontFamily = theme.fonts[globals_1.styles.global.body.fontFamily];
      var color = theme.colors[globals_1.styles.global.body.color];
      return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    ", "\n                    ", "\n                "], ["\n                    ", "\n                    ", "\n                "])), typefaces_1.typefaces, "\n                        body {\n                            font-family: " + fontFamily + ";\n                            color: " + color + "\n                        }\n                    ");
    }
  });
}

exports.GlobalStyles = GlobalStyles;
var templateObject_1;